import React, { useEffect, useState } from 'react';
import './css/index.scss';
import { message } from 'tdesign-react';
import ProductListBanner from './comps/ProductListBanner';
import { getProducts } from '@/tpss/apis/api';
import { IProduct } from '@/tpss/types';
import ProductListBody from './comps/ProductListBody';

interface ProductPageProps {}
const ProductPage: React.FC<ProductPageProps> = () => {
  const [products, setProducts] = useState<IProduct[]>([]);

  const getProductData = async () => {
    try {
      const products: any = await getProducts();
      setProducts(products.Data || []);
    } catch (error: any) {
      message.error(error.message);
    }
  };

  useEffect(() => {
    getProductData();
  }, []);

  return (
    <div className="page-proovr">
      <ProductListBanner products={products} />
      <ProductListBody products={products} />
    </div>
  );
};

export default ProductPage;
